// import React from 'react';
// import { Link } from 'react-router-dom';
// import heroBg from '../../images/slider/slide-bg-11.jpg'
// // import heroSlider from '../../images/slider/slide-11.jpg'

// const hero11 = () => {
//     const ClickHandler = () => {
//         window.scrollTo(10, 0)
//     }
//     return (
//         <section className="wpo-hero-static-s9" style={{ BackgroundImage: `url(${heroBg})` }}>
//             <div className="content">
//                 <h2 className="fade_bottom"><span>Where Vision Meets</span> <br />
//                     Urban Excellence</h2>
//                 <p className="fade_bottom">Blaze is a trailblazing architecture agency renowned for its innovative approach
//                     to design, where creativity meets functionality.</p>
//                 <div className="hero-btn fade_bottom">
//                     <Link onClick={ClickHandler} to="/projects" className="shop-btn">Explore Our Work</Link>
//                 </div>
//             </div>
//             <div className="hero-right">
//                 <img src={`https://res.cloudinary.com/dexvxngzg/image/upload/v1765261104/slide-11.5c34756df174c3868d5a_iprxeb.jpg`} alt="" />
//             </div>
//         </section>
//     );
// };

// export default hero11;
// import React from 'react';
// import { Link } from 'react-router-dom';
// import heroBg from '../../images/slider/slide-bg-11.jpg'
// // import heroSlider from '../../images/slider/slide-11.jpg'

// const hero11 = () => {
//     const ClickHandler = () => {
//         window.scrollTo(10, 0)
//     }
//     return (
//         <section className="wpo-hero-static-s9" style={{ BackgroundImage: `url(${heroBg})` }}>
//             <div className="content">
//                 <h2 className="fade_bottom"><span>Where Vision Meets</span> <br />
//                     Urban Excellence</h2>
//                 <p className="fade_bottom">Blaze is a trailblazing architecture agency renowned for its innovative approach
//                     to design, where creativity meets functionality.</p>
//                 <div className="hero-btn fade_bottom">
//                     <Link onClick={ClickHandler} to="/projects" className="shop-btn">Explore Our Work</Link>
//                 </div>
//             </div>
//             <div className="hero-right">
//                 <img src={`https://res.cloudinary.com/dexvxngzg/image/upload/v1765261104/slide-11.5c34756df174c3868d5a_iprxeb.jpg`} alt="" />
//             </div>
//         </section>
//     );
// };

// export default hero11;
import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../../images/slider/slide-bg-11.jpg';

const Hero11 = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const isMobile = window.innerWidth < 768;

    return (
        <section
            className="wpo-hero-static-s9"
            style={{
                backgroundImage: `url(${heroBg})`,
                overflowX: "hidden",
            }}
        >
            <div
                className="content"
                style={{
                    width: isMobile ? "100%" : "50%",
                    maxWidth: "90%",
                    paddingRight: "16px",
                    minWidth: "280px",
                }}
            >
                <h2
                    className="fade_bottom"
                    style={{
                        fontWeight: 900,
                        lineHeight: "1.02",

                        /* 🔥 Bigger than before */
                        fontSize: "clamp(48px, 7vw, 80px)",
                        
                    }}
                >
                   
                    Quality Homes for Modern Living
                </h2>

                <p
                    className="fade_bottom"
                    style={{
                        fontSize: "clamp(17px, 2.8vw, 22px)",
                        lineHeight: "1.6",
                        maxWidth: "560px",
                        marginTop: "18px",
                    }}
                >
                    Quality Homes And Builders delivers reliable residential
                    construction with superior craftsmanship, modern designs,
                    and a commitment to building homes that last.
                </p>

                <div
                    className="hero-btn fade_bottom"
                    style={{ marginTop: "28px" }}
                >
                    <Link
                        onClick={ClickHandler}
                        to="/projects"
                        className="shop-btn"
                        style={{
                            backgroundColor: "#FACD2B",
                            borderColor: "#FACD2B",
                            color: "#000",
                            padding: "14px 28px",
                            fontSize: "clamp(15px, 2.8vw, 18px)",
                        }}
                    >
                        View Our Projects
                    </Link>
                </div>
            </div>

            <div
                className="hero-right"
                style={{
                    width: isMobile ? "100%" : "50%",
                    marginTop: isMobile ? "28px" : "0",
                }}
            >
                <img
                    src="https://res.cloudinary.com/dexvxngzg/image/upload/v1765261104/slide-11.5c34756df174c3868d5a_iprxeb.jpg"
                    alt="Quality Homes And Builders Project"
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                    }}
                />
            </div>
        </section>
    );
};

export default Hero11;
